<!-- 调拨明细 -->
<template>
    <div class="page-content">
        <c-header pageName="调拨明细"></c-header>
        <div class="order-header flex">
            <section>调拨单号 : {{allocateSn}}</section>
        </div>
        <div class="button-tool flex">
            <label @click="onAllocateSubmit">调拨确认</label>
        </div>
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            :offset="100"
        >
            <div class="receive-item flex" v-for="(item,index) in orderList" :key="index">
                <div class="item-content">
                    <section>商品名称 : {{item.goodsName}}</section>
                    <section>国际条码 : {{item.barCode}}</section>
                    <section>数量 : {{item.qty}}</section>
                    <section>规格 : {{item.goodsModel}}</section>
                    <section>状态 : <span :class="item.status === 1 ? 'confirm' : 'unconfirm'"> {{item.status === 1 ? " 已确认" : " 未确认"}} </span></section>
                </div>
                <div class="item-icon" @click="onAllocateDetailSub(item.id,item.status)">
                    <i class="iconfont xiangyou"></i>
                    <!-- <span>确认</span> -->
                </div>
            </div>
        </van-list>
    </div>
</template>

<script >
import Header from "../components/headerNav.vue";
export default {
    data() {
        return {
            id: "",
            currentPage: 1,
            pageSize: 5,
            loading: false,
            finished: true,
            orderList: [],
            allocateSn: "",
            totalCount: 0
        };
    },
    components: {
        "c-header": Header
    },
    mounted() {
        this.id = this.$route.query.id;
        this.allocateSn = this.$route.query.allocateSn;
        this.getAllocateDetail();
    },
    methods: {
        // 状态切换
        statusChange(value) {
            this.currentPage = 1;
            this.orderList = [];
            this.getAllocateDetail();
        },
        // 获取调拨单列表
        getAllocateDetail() {
            let param = {
                pageSize: this.pageSize,
                pageNumber: this.currentPage,
                allocateId: this.id
            };
            this.$post(this.URL.allocateDetail, param).then(res => {
                if (res.success) {
                    this.totalCount = res.data.totalCount;
                    this.orderList = [...this.orderList, ...res.data.records];
                    if (res.data.totalPage > this.currentPage) {
                        this.finished = false;
                    } else {
                        this.finished = true;
                    }
                } else {
                    this.$toast.fail(res.message);
                }
                this.loading = false;
            });
        },
        // 加载更多
        onLoad() {
            if (!this.finished) {
                this.currentPage++;
                this.getAllocateDetail();
            }
        },
        // 详情
        goOrderDetail(id) {
            this.$router.push({
                path: "/allocateGoodsList",
                query: { id: id }
            });
        },
        // 明细确认
        onAllocateDetailSub(id,status) {
            if(status === 1){
                this.$router.push({
                    path: "/allocateGoodsList",
                    query: { id: id }
                });
                return;
            }
            this.$dialog
                .confirm({
                    message: "确认调拨明细?"
                })
                .then(() => {
                    this.$router.push({
                        path: "/allocateGoodsList",
                        query: { id: id }
                    });
                })
                .catch(() => {
                    // on cancel
                });
        },
        // 调拨确认
        onAllocateSubmit(){
            let param = {
                id:this.id
            };
            this.$post(this.URL.allocateSub, param).then(res => {
                if (res.success) {
                    this.$toast.success("确认成功");
                    this.$router.push("/allocate");
                } else {
                    this.$toast.fail(res.message);
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped >
.page-content {
    height: 100vh;
    align-content: flex-start;
}
.button-tool {
    height: 2.5rem;
    align-items: center;
    padding: 0.5rem 0.5rem 0.5rem 0.5rem;
    border-bottom: 0.2rem solid #f0f0f0;
    font-size: 0.9rem;
    label {
        display: inline-flex;
        margin-right: 0.5rem;
        height: 1.8rem;
        align-items: center;
        padding: 0 0.8rem;
        background-color: #dc6350;
        border-radius: 0.2rem;
        color: white;
    }
}
.order-header {
    font-size: 0.9rem;
    color: #444;
    padding: 0.5rem 0.5rem 0 0.5rem;
    height: 3rem;
    align-items: center;
}
.nav-tool {
    display: flex;
    width: 100%;
    height: 3rem;
    background-color: #dc6350;
    padding: 0 3rem;
    align-items: center;
    section {
        display: inline-flex;
        width: 7rem;
        justify-content: center;
        border: 1px solid #fff;
        height: 1.8rem;
        align-items: center;
        font-size: 0.9rem;
        color: white;
    }
    .activity {
        background-color: white;
        color: #dc6350;
    }
    section:nth-child(2) {
        border-left: none;
        border-right: none;
    }
    section:first-child {
        border-top-left-radius: 0.2rem;
        border-bottom-left-radius: 0.2rem;
    }
    section:last-child {
        border-top-right-radius: 0.2rem;
        border-bottom-right-radius: 0.2rem;
    }
}

.order-total {
    display: flex;
    width: 100%;
    height: 2.2rem;
    border-bottom: 1px solid #eee;
    align-items: center;
    padding-left: 0.5rem;
    font-size: 0.9rem;
}
.van-list {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    padding: 1rem 0.5rem;
    font-size: 0.85rem;
    padding: 0.5rem 0.8rem;
    color: #444;
    .receive-item {
        padding: 0.5rem 0;
        border-bottom: 1px dashed #eee;
        .item-content {
            display: inline-flex;
            width: 90%;
            flex-wrap: wrap;
            section {
                display: flex;
                width: 100%;
                line-height: 1.2rem;
            }
            .confirm {
                padding-left: 0.3rem;
                padding-right: 0.3rem;
                color: white;
                background-color: green;
                border-radius:0.2rem;
                font-size: 0.7rem;
            }
            .unconfirm {
                padding-left: 0.3rem;
                padding-right: 0.3rem;
                color: white;
                background-color: #dc6350;
                border-radius:0.2rem;
                font-size: 0.7rem;
            }
        }
        .item-icon {
            display: inline-flex;
            width: 10%;
            align-items: center;
            justify-content: flex-end;
            span {
                background-color: #dc6350;
                color: white;
                font-size: 0.8rem;
                width: 4rem;
                height: 1.5rem;
                line-height: 1.5rem;
                text-align: center;
                border-radius: 0.2rem;
            }
            i {
                font-size: 1.5rem;
                color: #dc6350;
            }
        }
    }
    >>> .van-list__loading {
        display: flex;
        width: 100%;
        justify-content: center;
    }
    >>> .van-list__finished-text {
        display: flex;
        width: 100%;
        justify-content: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/AllocateDetail.vue